import sgaBurden from "./sga-burden";
import certificationChecklist from "./certification-checklist";
import ssrCommissions from "./ssr-commissions/all";
import sbCommissions from "./sb-commissions/all";
import capitalExpenditure from "./capital-expenditure/all";
import checkRecon from './check-recon/all';

export default function (nameController, nameAction, namePage) {
    if (nameAction === 'sgaburdenother') sgaBurden();
    if (nameAction === 'certificationchecklist') certificationChecklist();
    if (nameAction === 'ssrcommissions') ssrCommissions(namePage);
    if (nameAction === 'sellerbuildercommissions') sbCommissions(namePage);
    if (nameController === 'capitalexpenditures') capitalExpenditure(nameAction, namePage);
    if (nameController === 'checkrecon' && namePage === 'entry')  checkRecon(namePage);
}

/*General Functions for all Finance*/